import { store } from "@/stores/store";
import { setCurrentLeadId } from "@/features/leads/stores/leadFunctionalSlice";

/**
 * Open a lead from anywhere on the phone, optionally on one of its deals.
 * The id goes through the same `setCurrentLeadId` every desktop caller uses
 * (deferred a frame, as `useOpenLead` does, so the tap that asked cannot land
 * on the sheet's overlay); the deal is parked for MobileLeadHost to hand to
 * ViewLead as `defaultChildId`.
 */
let pendingChild: number | null = null;

export function openLead(leadId: number, childId?: number | null): void {
  if (!Number.isFinite(leadId) || leadId <= 0) return;
  pendingChild = childId ?? null;
  window.setTimeout(() => store.dispatch(setCurrentLeadId(leadId)), 16);
}

export function takePendingChild(): number | null {
  const c = pendingChild;
  pendingChild = null;
  return c;
}
